import { useAvailableShareActions } from 'src/app/shared/hooks/share';

import { useShareChannels } from '../useShareChannels';

import { useShareOptions } from './options';

export function usePsfShareAvailableShareActions() {
	const options = useShareOptions();
	const channels = useShareChannels();
	return useAvailableShareActions(channels, options);
}
